import { useState, useEffect } from 'react'

interface UseDialogSession {
  showDialog: boolean
  markDialogAsShown: () => void
}

/**
 * Hook to track whether the dialog is shown in the given session
 */
export const useDialogSession = (sessionKey: string): UseDialogSession => {
  const [showDialog, setShowDialog] = useState<boolean>(false)

  useEffect(() => {
    /** Check if the dialog has already been shown in this session */
    const isDialogShown = sessionStorage.getItem(sessionKey)
    if (!isDialogShown) {
      setShowDialog(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /** Mark the dialog as shown in sessionStorage */
  const markDialogAsShown = (): void => {
    sessionStorage.setItem(sessionKey, 'true')
    setShowDialog(false)
  }

  return { showDialog, markDialogAsShown }
}
